import React from 'react';

import LdapContainer from '@src/components/usergroup/ldapsync/LdapContainer';
import { ProgressTrackerTypeEnum } from '@src/model/progresstracker/ProgressTracker';

const AdminLdapPage = () => <LdapContainer type={ProgressTrackerTypeEnum.LDAP_LOG} />;

export default AdminLdapPage;
